<template>
	<div>
		<div  class="widget my-5" :class="widgetClass" :style="widgetStyle" v-for="widget in widgets">
			<h2>{{ widget.title }}</h2>
			<p>{{ widget.subtitle }}</p>
			<div>
				<SliderQ
					:maxNumSlides="4"
					:minSizeOfSlide="150"
				>
					 <slide v-for="item in widget.products" class="recipe-box">
						
						<div
							class="extra-box shadow-box"
						>

							<div
								class="extra-img"
								@click="openModalExtra(item)"
							>
								<progressive-image
									:src="item.images.small
										? item.images.small
										: item.images.big"
								/>

								<div class="extra-shadow"> 
									
								</div>
						        <div
						          class="container-recipe-tags"
						        >
						          <tags-line-orange
						            :items="item.marketingTags"
						          />
											<span class="promo-button" v-if="item.price && item.discount.value > 0">Promo</span>
						        </div>


							</div>	


							<div class="extra-info-block">
									
								<div :class="{'flex': $mq.isDesktop()}">
									<div
										class="extra-title trunced"
										v-html="item.title"
									></div>

									<div class="extra-price flex-right">
										<nobr>{{ item.price | priceFilter }}</nobr>
										<div class="d-flex promo-price" v-if="item.price && item.discount.value > 0">
											<small class="text-danger text-bold"> - {{item.discount.value * 100}} %</small>
											<small class="px-3 text-muted">|</small>
											<small class="text-muted text-decoration-line-through">€ {{item.discount.original}}</small>
          					</div>
									</div>
								</div>

								<slot name="description" />

							</div>

							<div v-if="item.product.supplier.name" class="extra-prod flex-bottom flex px-3">
								<div>
									<img src="../assets/img/supplier-icon.png" class="supplier-icon"> {{ item.product.supplier.name }}
								</div>

								<div v-if="item.product.weight" class="flex-right">
									{{ item.product.weight }} g
								</div>
							</div>
				

		            		<div class="px-3 mb-2">
		            			<cart-product :updating.sync="updating" :order="order" :item="item.original" :type='item.type' />
		            		</div>
						</div>

			        </slide>
		    	</SliderQ>
			</div>
		</div>
	</div>
</template>

<script>


import { WidgetApi } from '../api/WidgetApi'
import { ExtraApi } from '../api/ExtraApi'
import { Product } from '../core/Product'
import CartProduct from './Ecommerce/CartProduct'
import TagsLineOrange from './Parts/TagsLineOrange'
import Snackbar from './Elements/Snackbar'

export default {
	components: {
		CartProduct,
    TagsLineOrange,
		Snackbar
	},
	props: {
		vars: {
			type: Object,
			default: function () {
				return {}
			}
		},
		widgetStyle: {
			type: Object,
			default: function () {
				return {}
			}
		},
		widgetClass: {
			type: Object,
			default: function () {
				return {}
			}
		}
	},


	computed: {
		user() {
		  return this.$root.user;
		},
		order() {
			return this.user ? this.user.order : null
		},
	    tagsMarketing (item) {
	      return item.marketingTags
	    },
	},
	data () {
		return {
			products: [],
			updating: false,
			widgets: []
		}
	},

	methods: {
		openModalExtra (item) {
			this.$router.push({name: 'product', params: {id: item.id, slug: 'preview'} } )
		},
		load() {
			let api = new WidgetApi();

			api.all({}).then(response => {
				let widgets = Object.values(response.body.data.resources)

				widgets = widgets.filter(i => {

					// filter by url after new widget will be created
					let source = i.keys['Attiva quando user source'];

					if (!source) {
						return true;
					}
					
					return source.split(",").indexOf(this.$root.source || 'default') !== -1;

				}).filter(i => {
					try {
						return window.location.href.match(new RegExp(i.url))
					} catch (e) {
						return false;
					}
				}).filter(i => {

					let cg1 = i.keys['Attiva quando cg1'];

					if (!cg1) {
						return true;
					}

					if (!this.vars.product) {
						return false;
					}

					return this.vars.product.cg1.toLowerCase() == cg1.toLowerCase()
				}).filter(i => {

					let cg2 = i.keys['Attiva quando cg2'];

					if (!cg2) {
						return true;
					}
					
					if (!this.vars.product) {
						return false;
					}

					return this.vars.product.cg2.toLowerCase() == cg2.toLowerCase()
				}).filter(i => {

					let marketingTag = i.keys['Attiva quando marketingTag ID'];

					if (!marketingTag) {
						return true;
					}

					if (!this.vars.product) { // Product Required
						return false;
					}

					let needle = this.vars.product.tagsRaw.findIndex(i => {
						return marketingTag.split(",").indexOf(`${i.id}`) != -1;
					});

					return needle != -1
				})
				
				if (widgets.length == 0) {
					return;
				}

				this.widgets = []

				widgets.map((widget,key) => {


					let api = new ExtraApi();
					let query = []
					let sort_field = 'id'
					let sort_direction = 'asc'


					let ids = widget.keys['Filtra risultato per product ID'];

					if (ids) {
						query.push(`(id in (${ids.split(",")}))`)
					}

					let sort = widget.keys['Ordina per'];

					if (sort && sort.split(",").length == 2) {
						sort_field = sort.split(",")[0] 
						sort_direction = sort.split(",")[1] 
					}




					api.all({params: {
	                    show: 8,
	                    page: 1,
	                    sort_field: 'id',
	                    sort_direction: sort_direction,
	                    query: query.join(" and ")
	                }}).then(response => {
	                	widget.products = response.body.data.resources.map(product => {
	                		return Product.createFromExtra(product)
	                	})
	                	this.widgets.push(widget)
	                })
				})


			});

		}
	},
	mounted () {
		this.load()
	}
}

</script>

<style scoped>
	.extra-box {
		text-align: center;
		display: flex;
		flex-flow: column;
		height: 100%;
	}

	.extra-prod {
		color: #8c8c8c;
		font-size: 13px;
	}

	.disabled {
		padding: 5px 20px;
		margin-top: 10px;
		color: var(--quomi-orange);
	}

	.enabled {
		padding: 5px 20px;
		margin-top: 10px;
		color: var(--quomi-primary);
	}

	.extra-info-block {
		padding: 20px 15px 0px 15px;
		text-align: right;
		display: flex;
   		flex-direction: column;
   		flex-basis: 100%;
	}
  .container-recipe-tags {
    position: absolute;
    margin-left: -5px;
    margin-top: -35px;
    min-height: 35px;
    padding: 5px 15px;
    z-index: 1;
    bottom: 0;
    margin-bottom: -15px;
  }

	.extra-box.border-green {
		border: 1.5px solid var(--quomi-primary);;
	}

	.extra-price {
		font-size: 22px;
		font-weight: bold;
	}

	.extra-title {
		text-align: left;
		font-size: 16px;
		margin-right: 10px;
		margin-bottom: 10px;
		overflow: hidden;
	}

	.extra-title.trunced {
		display: -webkit-box;
	    -webkit-line-clamp: 2;
	    -webkit-box-orient: vertical;
	    height: 50px;
	    margin-bottom: 10px;
	    word-break: break-word;
	}

	.btn.full {
		width: 100%;
	} 

	.btn {
		margin-bottom: 0px;
	}

	.extra-img {
		cursor: pointer;
		position: relative;
	}

	.extra-shadow {
	    position: absolute;
	    left: 0;
	    right: 0;
	    bottom: 0;
	    height: 60px;
	    background: linear-gradient(0deg,rgba(0, 0, 0, 0.12) 0,rgba(0, 0, 0, 0) 60%,transparent);
	    display: -ms-flexbox;
	    display: flex;
	    -ms-flex-align: center;
	    align-items: center;
	}

	.extra-action {
		display: flex;
		flex-wrap: nowrap;
		font-weight: bold;
		align-items: center;
		justify-content: center;
		min-height: 47px;
	}

	.extra-action .flex-right {
		display: flex;
	}

	.extra-action button {
		padding: 5px 20px;
		background-color: var(--quomi-primary);
		color: white;
		border: 1.5px solid var(--quomi-primary);
	}

	.extra-action .btn:not(.full) {
		font-size: 18px;
		padding: 3px 15px;
	}

	.extra-action button.full {
		background-color: var(--quomi-primary);
		color: white;
	}

	.extra-action .quantity-extra {
		padding: 5px 20px;
		z-index: 1;
	}

	.supplier-icon {
		width: 15px;
		padding-bottom: 3px;
	}

	.flex-bottom {
		margin-top: auto;
	}

	.not-in-box {
		background: white !important;
		color: var(--quomi-primary) !important;
	}

	@media(max-width: 768px) {

		.extra-title {
			font-size: 13px;
		}

		.extra-title.trunced {
	    height: 60px;
	}

		.extra-action .quantity-extra {
			padding: 5px 10px;
		}

		.extra-info-block {
			padding: 10px;
			text-align: left;
		}
	}

	.recipe-box {
	    flex-basis: calc(100% / 4 - 20px);
	    max-width: calc(100% / 4 - 20px);
	    margin: 5px 10px !important;
			box-shadow: -2px 5px 5px #ededed;
	}

	.promo-button{
		padding: 0 8px;
		border: 2px solid white;
    border-radius: 5px;
		text-transform: uppercase;
    font-size: 13px;
		font-weight: bold;
    background: red;
    color: white;
	}

	.promo-price {
		width: max-content;
	}


	@media (max-width: 1324px) {
	    .recipe-box {
	        flex-basis: calc(100% / 3 - 20px);
	        max-width: calc(100% / 3 - 20px);
	    }
	}

	@media (max-width: 900px) {
	    .recipe-box {
	        flex-basis: calc(100% / 2 - 20px);
	        max-width: calc(100% / 2 - 20px);
	    }
	}
</style>
